module.exports = __webpack_public_path__ + "media/images/emblems/Wald-blazon-0eb416aade5f17a2c9c88399f0062bd1.svg";